module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"upgradeSuccess":"Вы перешли на новый тариф","downgradeSuccess":"Вы запланировали смену тарифа на «{plan}» с {date}","renewSuccess":"Подписка возобновлена","paymentSuccess":"Платёж прошел успешно","prolongSuccess":"Продление подписки прошло успешно"}}')
  delete Component.options._Ctor
}
